<div class="flex items-center justify-center">
  <ng-container *ngIf="!formAberto">
    <button
      *isAllowed="[ERoleAdminString.Admin, 'theme.create']"
      type="button"
      class="w-80 btn btn--secondary mr-5"
      (click)="formAberto = true"
    >
      Cadastrar Novo
    </button>
  </ng-container>

  <button
    *ngIf="formAberto"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formAberto = false"
  >
    X
  </button>
</div>

<ng-container *ngIf="formAberto">
  <h1 class="text-lg font-bold leading-3">CADASTRAR NOVO TEMA</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar um novo tema</small>

  <form class="flex flex-col gap-5" [formGroup]="formTheme">
    <div class="flex flex-col gap-3 md:flex-row">
      <div class="w-full wrapper">
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> Nome do tema: </label>
          <input type="text" class="form-input" placeholder="Nome do tema" formControlName="themeName" />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> URL do logo principal: </label>
          <input type="text" class="form-input" placeholder="https://..." formControlName="logoUrl" />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> URL do logo para impressão: </label>
          <input type="text" class="form-input" placeholder="https://..." formControlName="logoPrintUrl" />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> Parceiro: </label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Parceiro"
            formControlName="partnerId"
            (change)="onPartnerChange($event)"
          >
            <ng-option *ngFor="let partner of partners" [value]="partner.id">
              {{ partner.name }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> Cor primária (App Mobile): </label>
          <input
            type="color"
            class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            formControlName="primaryColor"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> Cor secundária (App Mobile): </label>
          <input
            type="color"
            class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            formControlName="secondaryColor"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2"> Cor de destaque (App Mobile): </label>
          <input
            type="color"
            class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            formControlName="accentColor"
          />
        </div>
        <div *isAllowed="[ERoleAdminString.Admin, 'theme.create']" class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="companyId"> Empresas: </label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [searchable]="false"
            placeholder="Empresas"
            formControlName="companyIds"
            id="companyIds"
            [multiple]="true"
          >
            <ng-option *ngFor="let company of companies" [value]="company.id">
              {{ company.name }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'theme.create']"
            (click)="sendPartnerTheme()"
            class="h-9 mt-7 btn btn--secondary"
          >
            + Salvar Tema
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
